module.exports = "<div class=\" d-flex flex-column offset-lg-1\">\n  <h2>Participants</h2>\n  <app-participant\n    *ngFor=\"let participant of participants\"\n    [participant]=\"participant\"\n    class=\" d-flex align-content-center offset-lg-1\"\n  ></app-participant>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/participants/participants.component.html
// module id = ../../../../../src/app/participants/participants.component.html
// module chunks = main